export type CustomerGate = "loading" | "customer" | "denied";

type CustomerConfigState = {
  isFetching: boolean;
  isSuccess: boolean;
  data?: { customer_id?: string };
  currentData?: { customer_id?: string };
  enabled: boolean;
};

export const customerGate = ({
  isFetching,
  isSuccess,
  data,
  currentData,
  enabled,
}: CustomerConfigState): CustomerGate => {
  // Only a tenant without its config yet waits on the splash: a refetch would unmount the app, the editor mid-save included.
  if (isFetching && !currentData) {
    return "loading";
  }
  if ((isSuccess && !!data?.customer_id) || !enabled) {
    return "customer";
  }
  return "denied";
};
